import React from "react";

import Zestawieniahtml from './Zestawienia_html.js';

import PrintComponents from "react-print-components";



export default class Print extends React.Component {

    constructor(props) {

        super(props);


    }



    render() {
        return (
        <PrintComponents trigger={<button type="button" class="btn btn-light float-right"><i class="fas fa-print"></i> Drukuj</button>} >
            <Zestawieniahtml text1={this.props.text1} data={this.props.data} stalytekst={this.props.stalytekst} grupaZestawienValuetext={this.props.grupaZestawienValuetext} uchwala={this.props.uchwala} czyuwagi={this.props.czyuwagi} zestawienieValue={this.props.zestawienieValue}/>   
        </PrintComponents>
        );

    }

}

